import React, { useState, useRef } from "react";
import styles from "./ChatPanel.module.css";
import { IoClose } from "react-icons/io5";
import { MdSend } from "react-icons/md";
import galleryIcon from "../../../assets/icons/gallery-icon.svg";
import chatIcon from "../../../assets/icons/chat-icon.svg";
import FileUpload from "../../Helpers/FileUpload/FileUpload";
import Chat from "../Chat/Chat";
import Modal from "../../UI/Modal/Modal";
import { useChatContext } from "../../../context/ChatContext";
import { getUser } from "../../../services/Auth";
import { useTranslation } from "react-i18next";

const ACCEPTED_FORMATS = ["application/pdf","video/mp4","image/png","image/jpeg"];

interface Props {
  handleClickClose: () => void;
}

const ChatPanel: React.FC<Props> = ({ handleClickClose }) => {
  const { messages, sendMessage, uploadFile } = useChatContext();
  const [chatActive, setChatActive] = useState(true);
  const [showFormatError, setShowFormatError] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const user = getUser();

  const { t } = useTranslation();

  const handleSubmit = (evt: React.FormEvent) => {
    evt.preventDefault();
    if (inputRef.current?.value.trim()) {
      sendMessage(inputRef.current.value);
      inputRef.current.value = "";
    }
  };

  const handleUploadFile = (file: File) => {
    if (!ACCEPTED_FORMATS.includes(file.type)) {
      setShowFormatError(true);
      return;
    }
    
    uploadFile(file);
  };

  return (
    <div className={styles.dialogContainer}>
      <nav className={styles.bar}>
        <div className={styles.barButtonsContainer}>
          <button onClick={() => setChatActive(true)} className={`${styles.buttonBar} ${chatActive ? styles.active : ""}`}>
            <img src={chatIcon} alt="" />
          </button>
          <button onClick={() => setChatActive(false)} className={`${styles.buttonBar} ${!chatActive ? styles.active : ""}`}>
            <img src={galleryIcon} alt="" />
          </button>
        </div>
        <button className={styles.buttonClose} onClick={handleClickClose}><IoClose /></button>
      </nav>

      <Chat messages={messages} userID={user.uuid} showMedia={!chatActive} />

      {chatActive && (
        <div className={styles.bottomBar}>
          <form onSubmit={handleSubmit} className={styles.inputContainer}>
            <input ref={inputRef} type="text" className={styles.inputChat} />
            <div className={styles.buttonsSend}>
              <FileUpload acceptedFormats={ACCEPTED_FORMATS} handleUploadFile={handleUploadFile} />
              <button type="submit"><MdSend /></button>
            </div>
          </form>
        </div>
      )}

      <Modal show={showFormatError} setShowModal={setShowFormatError}>
        <div className="dialog" style={{ textAlign: "center" }}>
          <h1 className="dialogTitle">{t("invalid_file_format_chat_message")}</h1>
          <button className={`button ${styles.closeButton}`} onClick={() => setShowFormatError(false)}>Close</button>
        </div>
      </Modal>
    </div>
  );
};

export default ChatPanel;